// @flow
import React, { useCallback, useMemo } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import { ActionCellContainer } from './columns/actions';
import { DateCell } from './columns/date';
import { StatusCell } from './columns/status';

import '../ui/table.css';
import './artlcles-list.css';

const ArticleListItem = props => {
	const { history, article, viewer, targetSection = 'article', columns, refetch } = props;
	const urlToItem = useMemo(() => `/articles/${article.section}/${article.id}`, [article]);

	const redirect = useCallback(() => history.push(urlToItem), [urlToItem]);

	if (targetSection === 'infoStrings') {
		return (
			<TableRow onClick={redirect} style={{ border: 0 }}>
				<TableRowColumn className="table--cell table--cell-body articles-table--title">
					<div className="table-fix-cell">{article.title}</div>
				</TableRowColumn>
				<TableRowColumn className="table--cell table--cell-body articles-table--info">
					<ActionCellContainer targetSection={targetSection} {...article} {...viewer} refetch={refetch} />
				</TableRowColumn>
			</TableRow>
		);
	}

	return (
		<TableRow onClick={redirect} style={{ border: 0 }}>
			<TableRowColumn className="table--cell table--cell-body articles-table--date">
				<DateCell article={article} />
			</TableRowColumn>
			<TableRowColumn className="table--cell table--cell-body articles-table--title">
				<a href={urlToItem} onClick={event => event.stopPropagation()} className="table-fix-cell pseudo-link">
					{article.title}
				</a>
			</TableRowColumn>
			<TableRowColumn className="table--cell table--cell-body articles-table--author">{article.authorName}</TableRowColumn>
			<TableRowColumn className="table--cell table--cell-body articles-table--state">
				<StatusCell state={article.state} />
			</TableRowColumn>
			<TableRowColumn className="table--cell table--cell-body articles-table--info">
				<ActionCellContainer {...article} {...viewer} />
			</TableRowColumn>
		</TableRow>
	);
};

export default withRouter(
	createFragmentContainer(ArticleListItem, {
		article: graphql`
			fragment ArticleListItem_article on Article {
				id
				section
				title
				section
				authorName
				categoryName
				availableAt
				hidden
				isArticleOfDay
				isArticleOfHour
				isEvent
				state
				mainPageOrder
				isEvent
				showInYandexNews
				showInYandexZen
				infostring
				infostring_hot
				mediaFiles {
					id
				}
				preview {
					type
				}
			}
		`,
	}),
);



// WEBPACK FOOTER //
// src/components/articles/ArticleListItem.js